import Vue from 'vue'
import Vuex from 'vuex'
import travaux from '../datas/travaux'
import aidesService from '../services/AidesService'
import entryParamsService from '../services/EntryParamsService'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    entryDatas: null,
    apiError: false,
    loadingAides: true,
    travaux: travaux,
    aides: [],
    city: ''
  },
  mutations: {
    setEntryDatas (state, datas) {
      state.entryDatas = datas
    },
    setApiError (state, error) {
      state.apiError = error
    },
    setLoadingAides (state, isLoading) {
      state.loadingAides = isLoading
    },
    setAidesDatas (state, aides) {
      state.aides = aides
    },
    setCity (state, city) {
      state.city = city
    }
  },
  actions: {
    initEntryParams ({ state, commit }) {
      if (state.entryDatas === null) {
        entryParamsService.init()
        commit('setEntryDatas', entryParamsService.getParams())
      }
    },
    getAides ({ state, commit }) {
      commit('setLoadingAides', true)
      const filters = {
        statut_beneficiaire: state.entryDatas.statutBeneficiaire,
        date_construction: state.entryDatas.dateConstruction,
        pourcentage_performance_globale: state.entryDatas.pourcentagePerfGlobal,
        travaux: state.entryDatas.travaux.length > 0 ? state.entryDatas.travaux.join(',') : null,
        aides_nationales: state.entryDatas.aidesNationales.length > 0 ? state.entryDatas.aidesNationales.join(',') : null,
        type_logement: state.entryDatas.typeLogement,
        nb_personnes_menage: state.entryDatas.nbPersonnesMenage,
        revenu_fiscal_reference: state.entryDatas.revenuFiscalReference
      }
      aidesService.getAides(state.entryDatas.codeInsee, filters)
        .then(response => {
          commit('setAidesDatas', response.data.donnees_aides)
          commit('setCity', response.data.donnees_geographique.commune.nom)
          commit('setLoadingAides', false)
          commit('setApiError', false)
        })
        .catch(error => {
          commit('setLoadingAides', false)
          if (error.response.status === 400) {
            commit('setApiError', 'une erreur est survenue lors de la récupération des aides : ' + error.response.data.message)
          } else {
            commit('setApiError', 'une erreur est survenue lors de la récupération des aides : ' + error)
          }
        })
    }
  }
})
